/**
 * The Supabase bearer every dashboard API client sends.
 *
 * One definition rather than one per client: how the dashboard
 * authenticates a request is a single fact about the app, and the
 * change that will eventually need making — a refresh-on-401, a tenant
 * header, an error type callers can branch on — has to land everywhere
 * at once or one endpoint quietly behaves differently from the rest.
 *
 * Returns `Record<string, string>` rather than `HeadersInit`: the union
 * is not indexable, and it is assignable to `HeadersInit` at every call
 * site anyway.
 */
import { supabase } from "../supabase";

export async function getAuthHeaders(
  includeContentType = true,
): Promise<Record<string, string>> {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session?.access_token) {
    throw new Error("Not authenticated");
  }
  const headers: Record<string, string> = {
    Authorization: `Bearer ${session.access_token}`,
  };
  if (includeContentType) {
    headers["Content-Type"] = "application/json";
  }
  return headers;
}
